import { PrognoseDetailPage } from "@/components/pg/prognose-detail-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/prognose/$articleNumber")({
  component: PrognoseDetailPage,
});
